// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "label--biJV";
var _3 = "submit-1flzQ";
export { _1 as "__esModule", _2 as "label", _3 as "submit" }
export default { "__esModule": _1, "label": _2, "submit": _3 }
